import router from '@/router'
import {userService} from '@/services'
export default function auth({ next, to}) {
    const loggedIn = userService.isLoggedIn()
    if (to.name !== 'login') { 
        next();
    }
    else { 
        if(loggedIn) {
            router.push({name: 'dashboard' })
        }
        return next();
    }
}